export default "__VITE_ASSET__CIWXh$rz__"